var map = {
	"./dinero.png": "e8ed",
	"./financer.png": "d46a",
	"./frinans.png": "361e",
	"./miranova.png": "59ac",
	"./mybanker.png": "dba4",
	"./nord-investments.png": "0241",
	"./nordombord.png": "468f",
	"./oekonomista.png": "e983",
	"./pengepugeren.png": "3282",
	"./rejsrejsrejs.png": "21d1",
	"./spainbyhanne.png": "5a3e",
	"./spiir.png": "b26a",
	"./tobi.png": "7a7d",
	"./travelmore.png": "cca2",
	"./vagabond.png": "80d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c47d";